var $									= require('jquery');

var _debounce							= require('lodash.debounce');
var helpers								= require('../helpers/helpers');
var urlParam							= require('../helpers/urlParam');
var getUrlQuery							= require('../helpers/getUrlQuery');

var bindEvent							= require('../eventHandlers/bindEvent');
var scrollEvent							= require('../eventHandlers/scrollEvent');
var clickHandler						= require('../eventHandlers/clickHandler');

var fastClick							= require('fastclick');
var head                                = require('headjs');
var countHomeNewsHeight 				= require('../functions/countHomeNewsHeight');
var countMainContentDetailsHeight		= require('../functions/countMainContentDetailsHeight');
var countStockModuleHeight				= require('../functions/countStockModuleHeight');
var bookingScripts			        	= require('../functions/bookingScripts');
var countTestimonialsModuleHeight		= require('../functions/countTestimonialsModuleHeight');
var countContentHeight					= require('../functions/countContentHeight');
var accordionTrigger					= require('../functions/accordionTrigger');
var bannerDotsPosition					= require('../functions/bannerDotsPosition');
var seasonChange						= require('../functions/seasonChange');
var filterOffers						= require('../functions/filterOffers');
var mobileNav							= require('../functions/mobileNav');
var spaFilter							= require('../functions/spaFilter');
var galleryInit							= require('../functions/galleryInit');
var movieGalleryInit					= require('../functions/movieGalleryInit');
var newsesScript						= require('../functions/newsesScript');
var modal								= require('../functions/modal');
var slicks								= require('../functions/slicks');

function initializeScripts() {
	var $holder = document.getElementById('holder'),
		$mapCanvas = document.getElementById('map-canvas'),
		$scrollToNextSection = document.querySelector('.scroll-next-section'),
		$html = document.getElementsByTagName('html')[0],
		$body = document.getElementsByTagName('body')[0],
		$accordionHld = document.getElementById('accordion-hld'),
		$newsesHld = document.getElementById('newses-hld'),
		$asideListingHld = document.querySelector('.aside-listing-hld'),
		$stockHld = document.getElementById('about-stock-hld'),
		$testimonialsHld = document.getElementById('testimonials-content-hld'),
		$listingFilters = document.querySelector('.listing-filters'),
		$sliderDots = document.querySelector('.photo-slider_dots-hld'),
		$contentBodyHldAttr = document.querySelector('.content-body-hld').getAttribute('data-hide-group'),
		$treatmentCategories = document.getElementById('treatments-categories'),
		$galleryView = document.querySelector('.gallery-big-hld'),
		$galleryClose = document.querySelector('.gallery-close'),
		$modalHld = document.querySelector('.modal-hld'),
		$fancybox = $('a.fancybox'),
		$mainContentNews = document.querySelector('.main-content--news'),
		$headEl = document.querySelectorAll('.head-el--can-click'),
		$scrollToTop = document.getElementById('scroll-to-top'),
		$navLink = document.querySelectorAll('.nav-footer-link'),
		$mainContent = document.querySelector('.main-content'),
		$asideRight = document.querySelector('.aside-right'),
		$movies = document.querySelector('.gallery-hld--movies'),
		$btnContact = document.querySelector('.btn--contact'),
		divCover = document.createElement('div');
		isSeason = getUrlQuery()["season"],
		$mobileNav = $('.header-nav-hld--mobile'),
		$contentForm = $('.content-form-hld select'),
		divCover.className = 'cover';

	fastClick(document.body);

	
	if($html.hasClass('touchevents')) {
		var $hasSubnodes = $('.has-subnodes');

		$hasSubnodes.on('click', function(e) {
			e.stopPropagation();

			var self = $(this);

			$('.subnav, .subnavi a').removeClass('active');
			self.addClass('active').next().addClass('active');

		});

		$('.nav-primary .has-subnodes').doubleTapToGo();

	}
	if($scrollToNextSection) {

		$scrollToNextSection.addEventListener('click', function() {

			if($body.hasClass('home') || $body.hasClass('generic')) {
				$.scrollTo(this.parentNode.nextElementSibling, 250, {axis: "y", offset: -88});
			} else {
				$.scrollTo(this.parentNode.nextElementSibling, 250, {axis: "y", offset: -49});
			}
			
		});

	}

	bindEvent(document.querySelector('.camera-link'), 'mouseenter', clickHandler);

	if($sliderDots) {

		bannerDotsPosition();

	}

	if($newsesHld) {

		countHomeNewsHeight();

		bindEvent(window, 'resize', _debounce(countHomeNewsHeight, 250));

	}

	if($asideListingHld) {

		countMainContentDetailsHeight();

		bindEvent(window, 'resize', _debounce(countMainContentDetailsHeight, 250));

	}

	if($stockHld) {

		countStockModuleHeight();

		bindEvent(window, 'resize', _debounce(countStockModuleHeight, 250));

	}

	if($btnContact) {

		$btnContact.addEventListener('click', function() {

			$.scrollTo(document.querySelector('.main-content-section--form'), 250, {axis: "y", offset: -49});

		});

	}


	if($testimonialsHld) {

		countTestimonialsModuleHeight();

		bindEvent(window, 'resize', _debounce(countTestimonialsModuleHeight, 250));

	}

	if($listingFilters) {

		filterOffers();

	}

	if($accordionHld) {

		accordionTrigger();

	}

	if($treatmentCategories) {

		spaFilter();

	}

	if($galleryView) {

		var siteLogoUrl = document.querySelector('.site-logo').getAttribute('href');

		galleryInit();

		$galleryClose.addEventListener('mouseenter', function() {
			this.setAttribute('href', siteLogoUrl);
		});

	}

	if($movies) {

		var siteLogoUrl = document.querySelector('.site-logo').getAttribute('href');

		movieGalleryInit();

		$galleryClose.addEventListener('mouseenter', function() {
			this.setAttribute('href', siteLogoUrl);
		});

	}

	if($modalHld) {

		modal();

	}

	if($contentForm) {
		$contentForm.SumoSelect();
	}

	if($fancybox.length) {
		$fancybox.fancybox({
			helpers: {
				thumbs: {
					width: 130,
					height: 75
				},
				overlay: {
					locked: false
				}
			}
		});
	}

	if($mainContentNews){

		newsesScript();

	}

	if($scrollToTop) {

		$scrollToTop.addEventListener('click', function() {

			$.scrollTo($body, 250, {axis: "y", offset: -49});

		});

	}

	if($mobileNav.length) {

		mobileNav();

	}

	if(!Modernizr.history) {

		$('.head-el--can-click').on('click', function() {

			if($(this).is('active')) {

				$(this).removeClass('active');
				$('body').removeClass('head-el-active');

				$('.cover').remove();

			} else {

				$('.head-el--can-click').removeClass('active');
				$('body').addClass('head-el-active');

				$(this).addClass('active');
				
				$holder.appendChild(divCover);

			}

			if(!$('body').hasClass('header-click')) {
				setTimeout(function() {
					$('body').addClass('header-click');
				}, 100);
			}

			if($(this).hasClass('head-el--weather-hld') && !$(this).hasClass('triggered')) {

				head.load("http://api.skiraport.pl/themes/mobile/js/dm-msg-modal.js",
                    "http://api.skiraport.pl/themes/mobile/js/dm-msg-client.js", function() {

					var $weatherIframe = $('.weather__iframe--async'),
						$weatherIframeAttr = $weatherIframe.attr('data-src');

					$('.head-el--weather-hld').addClass('triggered');

					$weatherIframe.attr('src', $weatherIframeAttr);

					$weatherIframe.removeAttr('data-src');				
							
				});

			}

		});

	} else {

		for(var i=0; i < $headEl.length; i++) {
			$headEl[i].addEventListener('click', function() {

				if(this.hasClass('active')) {

					this.classList.remove('active');
					$('body').removeClass('head-el-active');

					$('.cover').remove();

				} else {
				
					for(var i=0; i < $headEl.length; i++) {
						$headEl[i].classList.remove('active');
					}

					this.classList.add('active');
					$('body').addClass('head-el-active');

					$holder.appendChild(divCover);

				}

				if(!$body.hasClass('header-click')) {
					setTimeout(function() {
						$('body').addClass('header-click');
					}, 100);
				}

				if(this.hasClass('head-el--weather-hld') && !this.hasClass('triggered')) {

					head.load("http://api.skiraport.pl/themes/mobile/js/dm-msg-modal.js",
	                    "http://api.skiraport.pl/themes/mobile/js/dm-msg-client.js", function() {

						var $weatherIframe = document.querySelector('.weather__iframe--async'),
							$weatherIframeAttr = $weatherIframe.getAttribute('data-src');

						document.querySelector('.head-el--weather-hld').classList.add('triggered');

						$weatherIframe.setAttribute('src', $weatherIframeAttr);

						$weatherIframe.removeAttribute('data-src');

					});

				}

			});
		}
		
	}

	$('body').on('click', function() {
		if($body.hasClass('header-click')) {

			$body.classList.remove('head-el-active');
			$body.classList.remove('header-click');

			$('.head-el--can-click').removeClass('active');

			$('.cover').remove();
		}
	});

	if(divCover) {

		divCover.addEventListener('click', function() {
			for(var i=0; i < $headEl.length; i++) {
				$headEl[i].classList.remove('active');
			}

			$body.classList.remove('head-el-active');
			$body.classList.remove('header-click');

			$('.cover').remove();
		});

	}

	if($mainContent && $asideRight) {

		countContentHeight();

		bindEvent(window, 'resize', _debounce(countContentHeight, 250));

	}

	if( $('.movie-iframe').length ) {

		var isSafari = /constructor/i.test(window.HTMLElement);

		$('.movie-iframe').each(function() {
			var $this = $(this),
				iframeAttr = $this.attr('data-custom-src'),
				iframeSafariAttr = $this.attr('data-safari-src');
				iframeMobileAttr = $this.attr('data-mobile-src');

			if(isSafari && $('html').hasClass('desktop')) {

				if (typeof iframeSafariAttr !== typeof undefined && iframeSafariAttr.length) {
					$this.attr('src', iframeSafariAttr);
					$this.removeAttr('data-safari-src');
				}

			} else if($('html').hasClass('mobile')) {

				if (typeof iframeMobileAttr !== typeof undefined && iframeMobileAttr.length) {
					$this.attr('src', iframeMobileAttr);
					$this.removeAttr('data-mobile-src');
				}

			} else {

				if (typeof iframeAttr !== typeof undefined && iframeAttr.length) {
					$this.attr('src', iframeAttr);
					$this.removeAttr('data-custom-src');
				}

			}
		});

	}

	if($('.hide-sidebar').length) {
		$('.hide-sidebar').on('click', function() {
			$('.sidebar').toggleClass('hidden');
			$(this).toggleClass('active');

			$('.gallery-big-item').width($(window).width());
		})
	}

	if($('.main-news-item--event').length) {
	$('.main-news-item--event').on('click', function() {
			$(this).toggleClass('active').find('.main-news-description').slideToggle();
		});
	}

	$('img.camera').each(function() {
		var $img = $(this), 
			oldSrc = $img.attr('src'), 
			varPrefix = /\?/.test(oldSrc) ? '&' : '?';
		
		setInterval(function () {
			$img.attr('src', oldSrc + varPrefix + '_nocache=' + (+new Date()) )
		}, 60 * 1000);
	});

	if(isSeason && typeof isSeason !== 'undefined') {

		if(urlParam('season')){
			$('a[href]').filter(function(){
				if(!$(this).is('[target="_blank"], [data-change-season], .season-item') && $(this).attr('href') != '#'){
					return true;
				}
			}).each(function(){
				var $this = $(this),
					oldUrl = $this.attr('href'),
					special = '';
				if(oldUrl.indexOf("?") > -1){
					special = '&';
				} else {
					special = '?';
				}
				$this.attr('href', oldUrl + special + 'season=' + urlParam('season'));
			});
		}

	}

	$body.classList.add($contentBodyHldAttr);

	scrollEvent();
	slicks();
	seasonChange();

	var isIE11 = !!(navigator.userAgent.match(/Trident/) && navigator.userAgent.match(/rv[ :]11/));

	if(isIE11) {
		$body.classList.add('ie_10_11');
	}

	setTimeout(function() {
		$(window).lazyLoadXT();
	}, 50);

	if($('.ski-mobile-nav').length) {
		$('.ski-mobile-nav').on('click', function() {
			$(this).toggleClass('active');
		});
	}

	$('.site-logo').click(function() {
		$this = $(this);
		if ($this.attr('href').indexOf('?') != -1) {
			$this.attr('href', $this.attr('href')+'&noanimate=1');
		} else {
			$this.attr('href', $this.attr('href')+'?noanimate=1');
		}
	});

	if (($('html').hasClass('ios') || $('html').hasClass('safari')) && $('html').hasClass('mobile') && $('.iframe-wrapper').length) {
		function resizeIframeIpad() {
			var proportion = 0.5625;
			var iframe = $('.iframe-wrapper iframe');
			var iframeW = iframe.width();
			iframe.css('height', iframeW * proportion);
		}

		resizeIframeIpad();
		$(window).on('resize load', function() {
			resizeIframeIpad();
		});
		$(window).on('orientationchange', function() {
			setTimeout(function() {
				resizeIframeIpad();	
			}, 150);
		});
	}

	bookingScripts();
};

module.exports = initializeScripts;